<template>
    <div class="order-personage-form">
        <div v-if="canDelete" class="order-personage-form__delete">
            <button
                type="button"
                class="button users-repeater-item__delete"
                @click.prevent="$emit('delete', modelValue)"
            >
                <IconCross />
            </button>
        </div>
        <Grid gap-y="10">
            <Column>
                <FormField :label="$t('misc.name')" name="name" :error="error">
                    <FormInput
                        v-model="localPersonage.name"
                        :placeholder="$t('personages.list.namePlaceholder')"
                        class="form-input--compact order-personage-form__role-name"
                    />
                </FormField>
            </Column>
            <Column>
                <FormField :label="$t('misc.language')" name="language" :error="error">
                    <LanguageSelect
                        v-model="localPersonage.language"
                        :languages="languages"
                        width="100%"
                        @select="onLanguageSelect"
                    />
                </FormField>
            </Column>
            <Column>
                <FormField :label="$t('personages.list.speaker')" name="speaker" :error="error">
                    <SpeakerSelect
                        v-model="localPersonage.speaker"
                        :speakers="speakers"
                        igone-speaker-tags
                        width="100%"
                        :empty-text="
                            localPersonage.language
                                ? $t('editor.toolbar.noVoices')
                                : $t('upload.selectLanguage')
                        "
                    />
                </FormField>
            </Column>
        </Grid>
    </div>
</template>

<script>
import { fetchSpeakers } from '@speechki-frontend/core/editor/api/speakers';
import { FormField, FormInput } from '@speechki-frontend/shared/ui/forms';
import SpeakerSelect from '@speechki-frontend/shared/ui/SpeakerSelect';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { IconCross } from '@speechki-frontend/shared/ui/icons';
import LanguageSelect from '@speechki-frontend/shared/ui/LanguageSelect';

export default {
    name: 'OrderPersonageForm',
    components: {
        FormField,
        FormInput,
        SpeakerSelect,
        Grid,
        Column,
        IconCross,
        LanguageSelect,
    },
    props: {
        languages: {
            type: Array,
            default: () => [],
        },
        commonLanguage: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        initialPersonage: {
            type: Object,
            default: () => ({}),
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
        error: {
            type: Object,
            default: () => {},
        },
        limit: {
            type: Number,
            default: 0,
        },
    },
    emits: ['update:modelValue', 'delete', 'clearSpeaker'],
    data() {
        return {
            speakers: [],
            localPersonage: { ...this.modelValue },
        };
    },
    watch: {
        modelValue(val) {
            this.localPersonage = { ...val };
        },
        localPersonage: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', val);
            },
        },
        'localPersonage.language': {
            immediate: true,
            handler(language) {
                this.fetchSpeakers(language || this.commonLanguage);
            },
        },
    },
    methods: {
        async fetchSpeakers(language) {
            this.speakers = await fetchSpeakers({ book_language: language, limit: this.limit });
        },
        async onLanguageSelect({ slug }) {
            this.$emit('clearSpeaker', slug);
            await this.fetchSpeakers(slug);
        },
    },
};
</script>

<style lang="scss" src="./OrderPersonageForm.scss"></style>
